module.exports = __webpack_public_path__ + "img/decision.9acdbaef.svg";